import { createReducer } from 'redux-create-reducer'
import { CAMPAIGN_LIST_FILTER } from '@disco/constants/ActionTypes'
export type State = {
  typeFilter: null | 'campaign' | 'briefing'
}
const initialState: State = {
  typeFilter: null,
}
export const campaignListReducer = createReducer<State, any>(initialState, {
  [CAMPAIGN_LIST_FILTER](state, action) {
    return { ...state, typeFilter: action.campaignType }
  },
})
